import React from "react";
import logo from "../assets/img/logo-hcp-yeni.png";

const Footer = () => {
    return (
        <footer className="bg-white border-top py-5">
            <div className="container">
                <div className="row gy-4 justify-content-between text-center text-lg-start align-items-start">

                    {/* Logo ve Açıklama */}
                    <div className="col-lg-3">
                        <img
                            src={logo}
                            alt="HCP YAPI"
                            className="img-fluid mb-3"
                            style={{ maxWidth: "180px" }}
                        />
                        <p className="text-muted small mb-0">
                            Taahhüt-Mimarlık-Mühendislik firması olan HCP Yapı, sizlere, modern çağın ilerisine geçen projeleri sunmaya devam ediyor.
                        </p>
                    </div>

                    {/* Satış Ofisi */}
                    <div className="col-sm-6 col-lg-2">
                        <h6 className="fw-bold mb-3">SATIŞ OFİSİ</h6>
                        <ul className="list-unstyled small">
                            <li><a href="tel:+902323880891" className="text-dark text-decoration-none d-block">T: +90 (232) 388 08 91</a></li>
                            <li><a href="tel:+902323880891" className="text-dark text-decoration-none d-block">F: +90 (232) 388 08 91</a></li>
                            <li><a href="mailto:info@hcpyapi.com" className="text-dark text-decoration-none d-block">E: info@hcpyapi.com</a></li>
                            <li className="mt-2">
                                <a
                                    href="https://www.google.com/maps/place//data=!4m2!3m1!1s0x14bbd1c300566fcb:0xe25ed940de286a22?sa=X&ved=1t:8290&ictx=111"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-muted text-decoration-none"
                                >
                                    HCP Yapı Ahmet Efendi Mahallesi<br />1102 sok. No:1<br />Çiğli / İZMİR
                                </a>
                            </li>
                        </ul>
                    </div>

                    {/* Genel Merkez */}
                    <div className="col-sm-6 col-lg-2">
                        <h6 className="fw-bold mb-3">GENEL MERKEZ</h6>
                        <ul className="list-unstyled small">
                            <li><a href="tel:+902323880891" className="text-dark text-decoration-none d-block">T: +90 (232) 388 08 91</a></li>
                            <li><a href="mailto:info@hcpyapi.com" className="text-dark text-decoration-none d-block">E: info@hcpyapi.com</a></li>
                            <li className="mt-2">
                                <a
                                    href="https://www.google.com/maps/place//data=!4m2!3m1!1s0x14bbd1c300566fcb:0xe25ed940de286a22?sa=X&ved=1t:8290&ictx=111"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-muted text-decoration-none"
                                >
                                    HCP Yapı Ahmet Efendi Mahallesi<br />1102 sok. No:1 Çiğli / İzmir
                                </a>
                            </li>
                        </ul>
                    </div>

                    {/* Projeler */}
                    <div className="col-lg-3">
                        <h6 className="fw-bold mb-3">PROJELER</h6>
                        <ul className="list-unstyled small">
                            <li><a href="/projects/urla" className="text-dark text-decoration-none">HCP Urla</a></li>
                            <li><a href="/projects/green-park" className="text-dark text-decoration-none">Green Park</a></li>
                            <li><a href="/projects/karsiyaka-green" className="text-dark text-decoration-none">Karşıyaka Green</a></li>
                            <li><a href="/projects/bornova-green" className="text-dark text-decoration-none">Bornova Green</a></li>
                            <li><a href="#" className="text-dark text-decoration-none">Park Birebir Hayat</a></li>
                        </ul>
                    </div>

                </div>

                {/* Alt Kısım: Sosyal İkonlar */}
                <div className="d-flex justify-content-center gap-4 mt-4">
                    <a href="https://www.facebook.com/wwwhcpyapicom" target="_blank" rel="noopener noreferrer" className="text-dark">
                        <i className="icon-md fab fa-facebook-f" style={{ fontSize: '20px' }}></i>
                    </a>
                    <a href="https://www.instagram.com/hcp_yapi/" target="_blank" rel="noopener noreferrer" className="text-dark ml-2">
                        <i className="icon-md fab fa-instagram" style={{ fontSize: '20px' }}></i>
                    </a>
                    <a href="https://youtube.com/@hcpyapi939" target="_blank" rel="noopener noreferrer" className="text-dark ml-2">
                        <i className="icon-md fab fa-youtube" style={{ fontSize: '20px' }}></i>
                    </a>
                </div>
                <div className="d-flex justify-content-center gap-4 mt-4" style={{ fontSize: '13px' }}>
                    <span className="text-dark text-decoration-none mr-1">Designed By</span>
                    <a href="http://www.karyasmd.com?utm_source=hcp&utm_medium=footer" className="text-decoration-none" target="_blank" rel="noopener noreferrer" >
                        Karya SMD
                    </a>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
